import getISODate from '../../../functions/get-iso-date.js'

const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24

class DateRange {
  /**
   * Create new date range
   * @param {HTMLElement} container Containing element
   */
  constructor (container) {
    this.formSubmitButton = document.querySelector('#license-submit')
    /** @type {HTMLDivElement} */
    this.warning = container.querySelector('.js-date-range-warning')

    /** @type {HTMLDivElement} */
    this.warningMin = container.querySelector('.js-date-range-warning-min')

    /** @type {HTMLDivElement} */
    this.warning2 = container.querySelector('.js-date-range-warning2')

    /** @type {HTMLDivElement} */
    this.error = container.querySelector('.js-date-range-error')

    /** @type {HTMLDivElement} */
    this.errorMin = container.querySelector('.js-date-range-error-min')

    /** @type {HTMLInputElement} */
    this.startInput = container.querySelector('.js-date-range-start')

    /** @type {HTMLInputElement} */
    this.endInput = container.querySelector('.js-date-range-end')

    this.warningThreshold = parseInt(container.dataset.warningThreshold)
    this.warning2Threshold = parseInt(container.dataset.warning2Threshold) || 0
    this.warningThresholdMin = parseInt(container.dataset.warningThresholdMin) || 0
    this.errorThreshold = parseInt(container.dataset.errorThreshold)
    this.errorThresholdMin = parseInt(container.dataset.errorThresholdMin) || 0
  }

  init () {
    this.startInput.addEventListener('change', () => this.checkDate())
    this.endInput.addEventListener('change', () => this.checkDate())

    this.setMinDate()
  }

  get date () {
    if (!this.startInput.value || !this.endInput.value) {
      return null
    } else {
      return {
        start: new Date(this.startInput.value),
        end: new Date(this.endInput.value)
      }
    }
  }

  checkDate () {
    const date = this.date

    if (!date) {
      return
    }

    const difference = (date.end - date.start) / MILLISECONDS_IN_DAY

    this.setMinDate()

    if (difference < 0) {
      this.endInput.value = getISODate(date.start)
    }

    if (difference < this.errorThresholdMin) {
      this.hideAll()
      this.showErrorMin()
      this.disableSubmitButton()
      return
    }

    if (difference < this.warningThresholdMin) {
      this.hideAll()
      this.showWarningMin()
      this.enableSubmitButton()
      return
    }

    if (difference >= this.errorThreshold) {
      this.hideAll()
      this.showError()
      this.disableSubmitButton()
      return
    }

    if (difference >= this.warningThreshold) {
      this.hideAll()
      this.showWarning()
      this.enableSubmitButton()
      return
    }

    if (difference < this.warning2Threshold) {
      this.hideAll()
      this.showWarning2()
      this.enableSubmitButton()
      return
    }

    this.hideAll()
    this.enableSubmitButton()
  }

  hideAll () {
    this.hideWarning2()
    this.hideWarning()
    this.hideWarningMin()
    this.hideError()
    this.hideErrorMin()
  }

  setMinDate () {
    if (this.date) {
      this.endInput.min = getISODate(this.date.start)
    }
  }

  showWarning () {
    if (this.warning) {
      this.warning.hidden = false
    }
  }

  hideWarning () {
    if (this.warning) {
      this.warning.hidden = true
    }
  }

  showWarning2 () {
    if (this.warning2) {
      this.warning2.hidden = false
    }
  }

  hideWarning2 () {
    if (this.warning2) {
      this.warning2.hidden = true
    }
  }

  showWarningMin () {
    if (this.warningMin) {
      this.warningMin.hidden = false
    }
  }

  hideWarningMin () {
    if (this.warningMin) {
      this.warningMin.hidden = true
    }
  }

  showError () {
    if (this.error) {
      this.error.hidden = false
    }
  }

  hideError () {
    if (this.error) {
      this.error.hidden = true
    }
  }

  showErrorMin () {
    if (this.errorMin) {
      this.errorMin.hidden = false
    }
  }

  hideErrorMin () {
    if (this.errorMin) {
      this.errorMin.hidden = true
    }
  }

  enableSubmitButton () {
    const validationErrors = document.querySelectorAll('.notification--error:not([hidden])')
    if (validationErrors.length) {
      return
    }

    if (this.formSubmitButton) {
      this.formSubmitButton.ariaDisabled = 'false'
      this.formSubmitButton.removeAttribute('disabled')
    }
  }

  disableSubmitButton () {
    if (this.formSubmitButton) {
      this.formSubmitButton.ariaDisabled = 'true'
      this.formSubmitButton.setAttribute('disabled', '')
    }
  }
}

const ranges = document.querySelectorAll('.js-date-range')
ranges.forEach(range => new DateRange(range).init())
